import { useEffect, useState } from "react";
import CMSForm from "../form/CMSForm";
import { Button, Collapse } from "antd";
import { FiFigma } from "react-icons/fi";
import { BiTrash } from "react-icons/bi";
import { useSelector } from "react-redux";
import { GroupInputs, Inputs } from "./inputs";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { fetchPageCreate } from "../../redux/slices/pageCreateSlice";
import { fetchModuleCreate } from "../../redux/slices/moduleCreateSlice";
import { fetchShowcaseCreate } from "../../redux/slices/showcaseCreateSlice";
import { fetchPageUpdate } from "../../redux/slices/pageUpdateSlice";
import { fetchShowcaseUpdate } from "../../redux/slices/showcaseUpdateSlice";
import { useTranslation } from "react-i18next";
import { fetchSeoCreate } from "../../redux/slices/seoCreateSlice";
import { fetchSeoGetSlug } from "../../redux/slices/seoGetSlugSlice";
import { fetchSeoUpdate } from "../../redux/slices/seoUpdateSlice";
import { fetchModuleUpdate } from "../../redux/slices/moduleUpdateSlice";
import { fetchModuleDelete } from "../../redux/slices/moduleDeleteSlice";

const { Panel } = Collapse;

const CreateTemplate = ({ page, slug }) => {
    const [formData, setFormData] = useState({ id: 0, file: [] });
    const [seoFormData, setSeoFormData] = useState({ id: 0 });
    const [groups, setGroups] = useState([]);
    const [openPanels, setOpenPanels] = useState([]);
    const template = useSelector((state) => state.template.template);
    const [deleteGroup, setDeleteGroup] = useState([])
    const formValues = Inputs();
    const { t } = useTranslation();
    const seoFormValues = useState([
        { label: `${t("title")}`, col: 6, key: "titletr", type: "text" },
        { label: `${t("title")} (EN)`, col: 6, key: "titleen", type: "text" },
        { label: `${t("slug")}`, col: 6, key: "slugtr", type: "text" },
        { label: `${t("slug")} (EN)`, col: 6, key: "slugen", type: "text" },
        { label: `${t("description")}`, col: 6, key: "descriptiontr", type: "textarea" },
        { label: `${t("description")} (EN)`, col: 6, key: "descriptionen", type: "textarea" },
        { label: `${t("keywords")}`, col: 6, key: "keywordstr", type: "text" },
        { label: `${t("keywords")} (EN)`, col: 6, key: "keywordsen", type: "text" },
    ]);
    const groupFormValues = GroupInputs();
    const dispatch = useDispatch();

    const handleAddGroup = () => {
        setGroups(prev => [
            ...prev,
            { id: Date.now(), data: {} }
        ]);
        setOpenPanels(prev => [...prev, groups.length]);
    };

    const handleGroupChange = (idx, newData) => {
        setGroups(prev =>
            prev.map((g, i) => i === idx ? { ...g, data: newData } : g)
        );
    };

    const handleRemoveGroup = (idx) => {
        setGroups(prev => prev.filter((_, i) => i !== idx));
        setOpenPanels(prev => prev.filter(i => i !== idx));
        setDeleteGroup(prev => [...prev, groups[idx].id]);
    };

    const handlePanelChange = (keys) => {
        setOpenPanels(keys.map(Number));
    };

    const getData = async () => {
        if (page) {
            setFormData({
                id: page?.id,
                file: Array.isArray(page?.showcases[0]?.files) ? page?.showcases[0]?.files : page?.showcases[0]?.files ? [page?.showcases[0]?.files] : [],
                pagetr: page?.title["tr"],
                pageen: page?.title["en"],
                slugtr: page?.slug["tr"],
                slugen: page?.slug["en"],
                pageType: page?.pageType,
                nametr: page?.showcases[0]?.title["tr"],
                nameen: page?.showcases[0]?.title["en"],
                titletr: page?.showcases[0]?.description["tr"],
                titleen: page?.showcases[0]?.description["en"],
                contenttr: page?.showcases[0]?.content["tr"],
                contenten: page?.showcases[0]?.content["en"],
                lineCount: page?.showcases[0]?.lineCount,
            });

            var seoData = await dispatch(fetchSeoGetSlug({ slug: page?.slug["tr"] || page?.slug["en"] }));
            if (seoData.payload) {
                var result = seoData.payload
                setSeoFormData({
                    id: result?.id,
                    slugtr: result?.slug["tr"],
                    slugen: result?.slug["en"],
                    titletr: result?.title["tr"],
                    titleen: result?.title["en"],
                    descriptiontr: result?.description["tr"],
                    descriptionen: result?.description["en"],
                    keywordstr: result?.keywords["tr"],
                    keywordsen: result?.keywords["en"],
                })
            }

            const modules = page?.showcases?.[0]?.modules || [];
            if (modules.length > 0) {
                setGroups(
                    modules.map(mod => ({
                        id: mod?.id,
                        data: { id: mod?.id, file: Array.isArray(mod?.files) ? mod?.files : mod?.files ? [mod?.files] : [], slug: mod?.slug["tr"], descriptiontr: mod?.description["tr"], descriptionen: mod?.description["en"], titletr: mod?.title["tr"], titleen: mod?.title["en"], file1: mod?.files[0], file2: mod?.files[1] },
                    }))
                );
                setOpenPanels(modules.map((_, idx) => idx));
            }
        }
    }

    useEffect(() => {
        getData();
    }, [page, template])

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // console.log("Sabit Alanlar:", formData);
            // console.log("Gruplar:", groups.map(g => g.data));
            const pageTitle = { "tr": formData.pagetr, "en": formData.pageen };
            const pageSlug = { "tr": formData.slugtr, "en": formData.slugen };
            var pageResponse = await dispatch(slug ? fetchPageUpdate({ id: formData.id, slug: pageSlug, title: pageTitle, pageType: template }) : fetchPageCreate({ slug: pageSlug, title: pageTitle, pageType: template }))
            if (pageResponse.payload) {
                var response = pageResponse.payload;
                if (response.id) {
                    var showcaseTitle = { "tr": formData.nametr, "en": formData.nameen };
                    var showcaseDescription = { "tr": formData.titletr, "en": formData.titleen };
                    var showcaseContent = { "tr": formData.contenttr, "en": formData.contenten };
                    var showcaseResponse = await dispatch(page?.showcases[0] ? fetchShowcaseUpdate({ id: page?.showcases[0]?.id, file: formData.file, title: showcaseTitle, description: showcaseDescription, content: showcaseContent, lineCount: formData.lineCount, pageId: response.id }) : fetchShowcaseCreate({ title: showcaseTitle, file: formData.file, description: showcaseDescription, content: showcaseContent, lineCount: formData.lineCount, pageId: response.id }))
                    if (showcaseResponse.payload) {
                        var response = showcaseResponse.payload;
                        if (response.id) {
                            if (groupFormValues[template - 1].length > 0) {
                                var modules = groups.map(g => g.data)
                                for (var i = 0; i < modules.length; i++) {
                                    var moduleTitle = { "tr": modules[i].titletr, "en": modules[i].titleen };
                                    var moduleSlug = { "tr": modules[i].slug, "en": modules[i].slug };
                                    var moduleDescription = { "tr": modules[i].descriptiontr, "en": modules[i].descriptionen };
                                    await dispatch(modules[i]?.id ? fetchModuleUpdate({ id: modules[i]?.id, slug: moduleSlug, title: moduleTitle, description: moduleDescription, file: modules[i].file, showcaseID: response.id }) : fetchModuleCreate({ title: moduleTitle, slug: moduleSlug, description: moduleDescription, file: modules[i].file, showcaseID: response.id }))
                                }
                            }
                        }
                    }
                }
                var seoTitle = { "tr": seoFormData.titletr, "en": seoFormData.titleen };
                var seoSlug = { "tr": seoFormData.slugtr, "en": seoFormData.slugen };
                var seoDescription = { "tr": seoFormData.descriptiontr, "en": seoFormData.descriptionen };
                var seoKeywords = { "tr": seoFormData.keywordstr, "en": seoFormData.keywordsen };
                await dispatch(seoFormData?.id ? fetchSeoUpdate({ id: seoFormData?.id, title: seoTitle, slug: seoSlug, description: seoDescription, keywords: seoKeywords, pageId: formData.id }) : fetchSeoCreate({ title: seoTitle, slug: seoSlug, description: seoDescription, keywords: seoKeywords, pageId: formData.id }))
                if (deleteGroup.length > 0) {
                    for (var i = 0; i < deleteGroup.length; i++) {
                        await dispatch(fetchModuleDelete({ id: deleteGroup[i] }))
                    }
                }
            }
            toast.success(`Sayfa başarıyla ${slug ? "güncellendi" : "oluşturuldu"}.`);
        } catch (error) {
            console.log("Error:", error);
            toast.error("An error occurred while creating the template.");
        }
    };

    useEffect(() => {
        setSeoFormData(prev => ({
            ...prev,
            titletr: formData.pagetr || "",
            titleen: formData.pageen || "",
            slugtr: formData.slugtr || "",
            slugen: formData.slugen || ""
        }));
    }, [formData.pagetr, formData.pageen, formData.slugtr, formData.slugen]);

    return (
        <div>
            <CMSForm
                setFormData={setFormData}
                formData={formData}
                formValues={formValues[template - 1]}
            />

            {groupFormValues[template - 1].length > 0 ? <>
                <Button type="dashed" onClick={handleAddGroup} className="mb-3">+ Öğe Ekle</Button>
                <Collapse activeKey={openPanels} onChange={handlePanelChange} accordion={false}>
                    {groups.map((group, idx) => (
                        <Panel
                            header={`Öğe ${idx + 1}`}
                            key={idx}
                            extra={<BiTrash style={{ color: "red", fontSize: 18 }} onClick={e => { e.stopPropagation(); handleRemoveGroup(idx); }} />}
                        >
                            <CMSForm
                                setFormData={newData => handleGroupChange(idx, newData)}
                                formData={group.data}
                                formValues={groupFormValues[template - 1]}
                            />
                        </Panel>
                    ))}
                </Collapse>
            </> : null}
            <div className="w-100 border border-dark my-4"></div>
            <div className="mb-3"><h4>{t("seo_settings")}</h4></div>
            <div>
                <CMSForm
                    setFormData={setSeoFormData}
                    formData={seoFormData}
                    formValues={seoFormValues[0]}
                    readOnlyFields={["titletr", "titleen", "slugtr", "slugen"]}
                />
            </div>
            <div className="w-100 my-4 d-flex justify-content-end">
                <Button className="ml-3" onClick={handleSubmit}><FiFigma /> Sayfayı {slug ? "güncelle" : "oluştur"}</Button>
            </div>
        </div>
    );
};

export default CreateTemplate;